import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { IntercityStop, ProductCategory, StopGroup } from '@ridango/core';

import { Observable } from 'rxjs';

import { StopsActions } from './stops.actions';
import { StopsPartialStoreState } from './stops.reducer';
import * as StopsSelectors from './stops.selectors';
import { map } from 'rxjs/operators';
import orderBy from 'lodash/orderBy';

@Injectable()
export class StopsFacade {
    filtered$: Observable<IntercityStop[]> = this.store.select(StopsSelectors.getFiltered);
    allAreasStatus$: Observable<boolean> = this.store.select(StopsSelectors.getAllAreas);
    byId$: Observable<IntercityStop[]> = this.store.select(StopsSelectors.getAllById);
    allOrigins$: Observable<IntercityStop[]> = this.store.select(StopsSelectors.getAllOrigins);
    groups$: Observable<ProductCategory[]> = this.store
        .select(StopsSelectors.getGroups)
        .pipe(map((groups) => orderBy(groups, 'order')));
    selectedGroup$: Observable<ProductCategory> = this.store.select(StopsSelectors.getSelectedGroup);
    selectedGroupMapFile$: Observable<string> = this.store.select(StopsSelectors.getSelectedGroupMapFile);
    selectedOrigin$: Observable<IntercityStop> = this.store.select(StopsSelectors.getSelectedOrigin);
    selectedDestination$: Observable<IntercityStop> = this.store.select(StopsSelectors.getSelectedDestination);

    constructor(private store: NgRedux<StopsPartialStoreState>, private actions: StopsActions) {}

    getStops() {
        this.store.dispatch(this.actions.fetchStart());
    }

    getIntercityStops() {
        this.store.dispatch(this.actions.fetchIntercityStopsStart());
    }

    getAllZones() {
        this.store.dispatch(this.actions.fetchZonesStart());
    }

    getStopsWithZones() {
        this.store.dispatch(this.actions.fetchStopsWithZonesStart());
    }

    setSelectedGroup(group: ProductCategory) {
        this.store.dispatch(this.actions.setSelectedGroup(group));
    }

    setSelectedOrigin(stop: IntercityStop) {
        this.store.dispatch(this.actions.setSelectedOrigin(stop));
    }

    setSelectedDestination(stop: IntercityStop) {
        this.store.dispatch(this.actions.setSelectedDestination(stop));
    }

    setAllAreasSelected(isSet: boolean) {
        this.store.dispatch(this.actions.setAllAreasSelected(isSet));
    }

    setSelectedStops(stops: any) {
        this.store.dispatch(this.actions.setSelectedStops(stops));
    }

    clearSelections() {
        this.store.dispatch(this.actions.clearAllSelections());
    }
}
